import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_female_pilates_bulk_update~1
		'activity-female-pilates': {
			funnel: {
				id: 'ob-female-pilates-bulk-update',
				locale: ['en'],
			},
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_female_pilates_bulk_update'
					),
			},
		},
	},
]

export default config
